import { render, staticRenderFns } from "./ContactForm.ts.vue?vue&type=template&id=7a454808&"
import script from "./ContactForm.ts.vue?vue&type=script&lang=ts&"
export * from "./ContactForm.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports